import { Component, Input } from '@angular/core';
import { IPortfolioDepositOut } from 'src/models/products.model';

@Component({
  selector: 'liberro-onetime-payment',
  standalone: false,
  templateUrl: './liberro-onetime-payment.component.html',
  styleUrl: './liberro-onetime-payment.component.less'
})
export class LiberroOnetimePaymentComponent {
  @Input({ required: true }) public depositInfo!: IPortfolioDepositOut;
  @Input({ required: true }) public specificSymbol!: string;
  @Input({ required: true }) public onetimeDepositAmount!: number;
  @Input() public showHeader? = false;
}
